// Standardized error message when server data cannot be retrieved.
export const rejectServerError = (rejectWithValue) =>
  rejectWithValue('Failed to retrieve data from server.');
